import { render } from "./SelectBrand.vue?vue&type=template&id=35097034&scoped=true"
import script from "./SelectBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBrand.vue?vue&type=script&setup=true&lang=js"

import "./SelectBrand.vue?vue&type=style&index=0&id=35097034&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35097034"],['__file',"src/views/recruitment/brand/SelectBrand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35097034"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35097034', __exports__)) {
    console.log('reload')
    api.reload('35097034', __exports__)
  }
  
  module.hot.accept("./SelectBrand.vue?vue&type=template&id=35097034&scoped=true", () => {
    console.log('re-render')
    api.rerender('35097034', render)
  })

}


export default __exports__